import styled from 'styled-components';
import BannerIcons from '../public/assets/images/banners/banner-icons.webp';
import ImageWrapper from './ImageWrapper';
import { useTranslation } from 'next-i18next';

const GetAppBanner = () => {
  const { t } = useTranslation('entity');
  return (
    <Container href="https://nawyapp.go.link//search?view=map&adj_t=1kq3oynr">
      <div>
        <span className="banner-text">{t('banner_header')}</span>
        <span className="download-text">{t('banner_download')}</span>
      </div>

      <ImageWrapper
        src={BannerIcons}
        alt="Banners Icons"
        width={125}
        height={105}
      />
    </Container>
  );
};

const Container = styled.a`
  display: flex;
  background: linear-gradient(
    54deg,
    #e7f5ff 22.29%,
    rgba(252, 252, 252, 0) 106.37%
  );
  box-shadow: 0px 2px 8px rgba(106, 106, 106, 0.19);
  border-radius: 8px;
  padding: 0px 16px;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 50%;

    .banner-text {
      color: #1a2028;
      font-family: materialBold;
      font-size: 14px;
      text-transform: capitalize;
    }

    .download-text {
      color: #ff5e00;
      font-family: materialSemiBold;
      font-size: 15px;
      text-transform: capitalize;
    }
  }
`;

export default GetAppBanner;
